import React, { Component } from 'react'

import '../styles/participant.css'

export default class GetTheAppContainer extends Component {

  comingSoon = (e) => {
    e.preventDefault();
    alert("Android app coming soon!");
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-6 offset-md-3 p-4 shadow-lg rounded baseline-evaluation">
            <h2>Download the EL-FIT App</h2>
            <p>
              Thank you for completing your baseline evaluation. You can come back to this website
              anytime to update your profile and change your information. Download the EL-FIT App
              for iOS or Android and sign-in to access the program.
            </p>

            <div className="get-the-app">
              <a className="option" href="https://apps.apple.com/us/app/el-fit/id6754848764">
                <div className="logo-container">
                  <img src={require('../images/ios.jpg')} alt="ios logo" />
                </div>
                <button className="btn btn-primary btn-block">Download for iOS</button>
              </a>

              <a className="option" href="https://play.google.com/store/apps/details?id=edu.northwestern.sarcofit3.elfit" >
                <div className="logo-container">
                  <img src={require('../images/android.png')} alt="android logo" />
                </div>
                <button className="btn btn-primary btn-block">Download for Android</button>
              </a>
            </div>
          </div>
        </div>

        <div className="row">
          <a
            href="/logout"
            style={{ color: 'rgba(255,255,255,0.8)', textAlign: 'center', margin: 'auto' }}
          >
            Sign Out
          </a>
        </div>
      </div>
    )
  }
}